/**
 * Single source of truth for header-related CSS custom properties.
 * Prevents layout shift by setting --header-height, --header-group-height,
 * and --transparent-header-offset-boolean. Called inline after #header-group
 * and by utilities.updateAllHeaderCustomProperties() (e.g. theme editor).
 */
window.setHeaderHeightCSSVars = function setHeaderHeightCSSVars() {
  const header = document.querySelector('header-component');
  const headerGroup = document.querySelector('#header-group');
  const hasHeaderSection = headerGroup?.querySelector('.header-section');

  if (!header || !headerGroup) return;

  const headerHeight = header.offsetHeight;

  let headerGroupHeight = 0;
  const children = headerGroup.children;
  for (let i = 0; i < children.length; i++) {
    const element = children[i];
    if (element === header || !(element instanceof HTMLElement)) continue;
    headerGroupHeight += element.offsetHeight;
  }

  if (header.hasAttribute('transparent') && header.parentElement?.nextElementSibling) {
    headerGroupHeight += headerHeight;
  }

  document.body.style.setProperty('--header-height', headerHeight + 'px');
  document.body.style.setProperty('--header-group-height', headerGroupHeight + 'px');

  if (!hasHeaderSection || !header.hasAttribute('transparent')) {
    document.body.style.setProperty('--transparent-header-offset-boolean', '0');
    return;
  }

  const hasImmediateSection = hasHeaderSection.nextElementSibling?.classList.contains('shopify-section');
  document.body.style.setProperty('--transparent-header-offset-boolean', hasImmediateSection ? '0' : '1');
};
